import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import { encodeQueryValue } from "./queryString";
import { catalogLegacyQuery, catalogListLimit, localCatalogAction } from "./catalogRequest";

const API_URL = config.API_URL;

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["gender"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, values[value].value);
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/suppliers/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["gender"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, values[value].value);
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/suppliers/update/" + values.id;
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const sort = values && values.sort;
  const dropdown = values && values.dropdown ? values.dropdown : "";
  const result = values && values.result ? values.result : "";
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      sortArray[index] = `sort[${key}]=${sort[key]}`;
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if(values){
    if(values.id){
      pagination = false;
    }
    if(values.option){
      pagination = false;
    }
    if (Object.prototype.hasOwnProperty.call(values, "pagination")) {
      pagination = values.pagination;
    }
  }
  const q = typeof (values && values.q) === "string" ? values.q : "";
  const queryString = [sortstring, q ? `q=${encodeQueryValue(q)}` : ""].filter(Boolean).join("&");
  const action = localCatalogAction("afterlogin/suppliers/view", values, queryString);

  let supplierdata;
  if (dropdown) {
    supplierdata = {
      auth_key: auth_key,
      action: action,
      pagination: false, //true or false
      id: "",
      result: result, //business_name,owner_name
    };
  } else {
    supplierdata = {
      auth_key: auth_key,
      action: action,
      pagination: pagination, //true or false
      id: values && values.id ? values.id : "",
      result: result, //business_name,owner_name
      option: values && values.option ? values.option : "",
    };
  }
  const limit = catalogListLimit(values);
  if (limit) supplierdata.limit = limit;
  const data = supplierdata;
  data.action = action;
  if (q) data.q = q;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/suppliers/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const suggetionlist = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  let q = typeof (values && values.q) === "string" ? values.q : catalogLegacyQuery(values, "q") || "";
  const encodedQ = encodeQueryValue(q);
  const action = localCatalogAction("afterlogin/suppliers/view", values, `q=${encodedQ}`);
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: true, //true or false
    id: values && values.id ? values.id : "",
    apicall:'suggetion',
    q,
  };
  const limit = catalogListLimit(values);
  if (limit) data.limit = limit;
  data.action = action;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const supplierApiController = {
  create,
  update,
  view,
  deleted,
  suggetionlist,
};
export default supplierApiController;
